module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }, [_c('p', {
    staticClass: "dedicationTextCenter"
  }, [_vm._v("For the people who experience the most painful suffering, "), _c('br'), _vm._v("who feel trapped and hopeless, "), _c('br'), _vm._v("who feel life makes no sense and seems utterly cruel—"), _c('br'), _vm._v("there is a place in the center of each moment, "), _c('br'), _vm._v("available right now, "), _c('br'), _vm._v("where freedom and compassionate truth wait "), _c('br'), _vm._v("to welcome all of us home.")])]), _c('a', {
    attrs: {
      "id": "pagevi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagevi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-763b7f9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416546375_ded01.vue
// module id = 69
// module chunks = 0